export enum PATHS {
  TRANSACTIONS = '/transactions',
  TRANSACTION_DETAILS = '/transactions/:transactionId',
  DEPOSIT = '/deposit',
  DEPOSIT_REQUESTS = '/deposit/requests',
  WITHDRAW = '/withdraw',
  MANAGE_ACCOUNT = '/manage_account',
  VERIFICATION = '/verification',
  VERIFICATION_FLOW = '/verification_flow',
  CLAIM_KYC = '/claim_kyc',
  VERIFICATION_MY_INFO_CALLBACK = '/callback/:myInfoParams',
  INTERNAL_TOOLS = '/internal_tools',
  ERROR = '/error/:code',
  ERROR_403 = '/error/403',
  LANDING_PAGE = '/',
}
